import React, { useState } from 'react';
import { Box } from '@mui/material';
import { SubjectList } from '../components/SubjectList';
import { SubjectForm } from '../components/SubjectForm';
import type { Subject } from '../types';
import { useSnackbar } from '../hooks/useSnackbar';
import { ToastNotification } from '../components/ToastNotification';

export const SubjectManagementPage: React.FC = () => {
  const [subjectFormOpen, setSubjectFormOpen] = useState(false);
  const [selectedSubject, setSelectedSubject] = useState<Subject | null>(null);
  const [isEditing, setIsEditing] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const { snackbar, showSuccess, showError, hideSnackbar } = useSnackbar();

  const handleAddSubject = () => {
    setSelectedSubject(null);
    setIsEditing(false);
    setSubjectFormOpen(true);
  };

  const handleEditSubject = (subject: Subject) => {
    setSelectedSubject(subject);
    setIsEditing(true);
    setSubjectFormOpen(true);
  };

  const handleSubjectSaved = (subject: Subject) => {
    const wasEditing = isEditing;
    setSubjectFormOpen(false);
    setSelectedSubject(null);
    setIsEditing(false);
    setRefreshTrigger(prev => prev + 1);
    showSuccess(wasEditing ? 'Cập nhật môn học thành công!' : 'Thêm môn học thành công!');
  };

  const handleSubjectSaveError = (error: string) => {
    showError(error);
  };

  return (
    <Box sx={{ p: 3 }}>
      <SubjectList
        onEdit={handleEditSubject}
        onAdd={handleAddSubject}
        refreshTrigger={refreshTrigger}
      />

      <SubjectForm
        open={subjectFormOpen}
        onClose={() => {
          setSubjectFormOpen(false);
          setSelectedSubject(null);
          setIsEditing(false);
        }}
        onSave={handleSubjectSaved}
        onError={handleSubjectSaveError}
        subject={selectedSubject}
        title={isEditing ? 'Chỉnh sửa môn học' : 'Thêm môn học mới'}
      />

      <ToastNotification
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={hideSnackbar}
      />
    </Box>
  );
};
